export enum MutationTypes {
    SET_IDTOKEN = "SET_IDTOKEN",
    SET_LOGINSESSIONID = "SET_LOGINSESSIONID",
    SET_APIURL = "SET_APIURL",
}
